import { render } from "./lithotherapie.vue?vue&type=template&id=785a4432&scoped=true"
import script from "./lithotherapie.vue?vue&type=script&lang=js"
export * from "./lithotherapie.vue?vue&type=script&lang=js"

import "./lithotherapie.vue?vue&type=style&index=0&id=785a4432&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785a4432"]])

export default __exports__